import { render, staticRenderFns } from "./Pending.vue?vue&type=template&id=22c39588&scoped=true"
import script from "./Pending.vue?vue&type=script&lang=js"
export * from "./Pending.vue?vue&type=script&lang=js"
import style0 from "./Pending.vue?vue&type=style&index=0&id=22c39588&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c39588",
  null
  
)

export default component.exports